import { ResultComponent } from './result/result.component'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { SegmentTagMap } from '../shared/analytics/models/segment-tag-map.model'
import { MetaGuard } from 'meta'
import { ResultsGuard } from './results.guard'
import { ResultsListResolver } from './results-list/results-list.resolver'
import { ResultsListComponent } from './results-list/results-list.component'
import { RESULTS_TAG } from './results-analytics.service'

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: ResultsListComponent,
        resolve: { results: ResultsListResolver },
        canActivate: [MetaGuard],
        data: {
          segment: RESULTS_TAG,
          shouldShowAdSkin: false,
          shouldShowEventTicker: true,
          noTopScroll: true,
          meta: {
            title: 'meta_result_page_title',
            description: 'meta_result_page_description'
          }
        }
      },
      {
        path: ':slug',
        canActivate: [MetaGuard, ResultsGuard],
        data: {
          segment: SegmentTagMap.RESULTS_DETAIL,
          shouldShowAdSkin: false,
          shouldShowEventTicker: true
        },
        children: [
          {
            path: ':resultSetId',
            component: ResultComponent
          }
        ]
      }
    ])
  ],
  exports: [RouterModule],
  providers: [ResultsGuard]
})
export class ResultsRoutingModule {}
